import {
  apps,
  sourceAccountId,
  dataClasses,
  environment,
  resourceType,
  sourceRegion,
  subnets,
  vpc,
  cloudProvider,
  resourceGroupName,
  tagKeys,
  tagKeyValues,
} from '@/components/queryBuilder/properties';
import { type FilterProperty } from '@/types/advanceFilter';

export const supportedControlProperties: FilterProperty[][] = [
  [resourceType, dataClasses, environment, apps],
  [
    cloudProvider,
    sourceAccountId,
    sourceRegion,
    vpc,
    subnets,
    resourceGroupName,
  ],
  [tagKeys, tagKeyValues],
];
